import { render, staticRenderFns } from "./BlockAccordions.vue?vue&type=template&id=025f4758&"
import script from "./BlockAccordions.vue?vue&type=script&lang=js&"
export * from "./BlockAccordions.vue?vue&type=script&lang=js&"
import style0 from "./BlockAccordions.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports